import { safeEmit } from "@/infra/sockets";

import { post } from "@/infra/rest";
import {
  GetExcelFromJSONRequest,
  GetExcelFromJSONResponse,
  QuestionnaireFillerRequest,
  QuestionnaireStructureRequest,
} from "../types/questionnaire";

export const emitQuestionnaireStructure = (
  data: QuestionnaireStructureRequest,
  callback?: (...args: any[]) => void,
) => {

  safeEmit("task:qa:structure:create", data, callback);

  return true;
};

export const emitQuestionnaireFiller = (
  data: QuestionnaireFillerRequest,
  callback?: (...args: any[]) => void,
) => {

  safeEmit("task:qa:filler:create", data, callback);

  return true;
};

export const getExcelFromJSON = async (data: GetExcelFromJSONRequest) => {
  return post<GetExcelFromJSONRequest, GetExcelFromJSONResponse>({
    url: `/v0/compliance/questionnaire-filler-json-to-excel`,
    data,
  });
};
